import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Instagram, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const { t, language } = useLanguage();

  const currentYear = new Date().getFullYear();

  const navLinks = [
  { to: '/', label: t('nav.home') },
  { to: '/services', label: t('nav.services') },
  { to: '/gallery', label: t('nav.gallery') },
  { to: '/about', label: t('nav.about') },
  { to: '/testimonials', label: t('nav.testimonials') },
  { to: '/contact', label: t('nav.contact') }];


  return (
    <footer data-testid="footer" className="bg-[#2C3333] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link
              to="/"
              data-testid="footer-logo"
              className="font-script text-4xl text-white hover:text-[#8DA399] transition-colors">
              Galene home
            </Link>
            <p className="mt-4 text-white/70 font-sans text-base leading-relaxed max-w-md">
              {t('footer.tagline')}
            </p>
            <div className="mt-6 flex items-center space-x-2 text-white/70">
              <span className="font-accent text-lg italic">
                {t('footer.certifications')}
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-serif text-lg mb-6">
              {language === 'en' ? 'Quick Links' : 'Enlaces Rápidos'}
            </h4>
            <nav className="space-y-3">
              {navLinks.map((link) =>
              <Link
                key={link.to}
                to={link.to}
                onClick={() => window.scrollTo(0, 0)}
                data-testid={`footer-link-${link.to.replace('/', '') || 'home'}`}
                className="block font-sans text-sm text-white/70 hover:text-[#8DA399] transition-colors">

                  {link.label}
                </Link>
              )}
            </nav>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="font-serif text-lg mb-6">
              {language === 'en' ? 'Connect' : 'Conectar'}
            </h4>
            <div className="space-y-4">
              <a
                href="https://www.instagram.com/galene_home/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="flex items-center space-x-3 text-white/70 hover:text-[#8DA399] transition-colors group">

                <Instagram className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span className="font-sans text-sm">@galene_home</span>
              </a>
              <a
                href="mailto:galenehome@gmail.com"
                data-testid="footer-contact-link"
                className="flex items-center space-x-3 text-white/70 hover:text-[#8DA399] transition-colors group">

                <Mail className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span className="font-sans text-sm">galenehome@gmail.com</span>
              </a>
              <div className="flex items-center space-x-3 text-white/70">
                <MapPin className="w-5 h-5" />
                <span className="font-sans text-sm">Spain</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="font-sans text-sm text-white/50">
              © {currentYear} Galene Home. {t('footer.rights')}.
            </p>
            <div className="flex items-center space-x-6">
              <span className="!font-sans !text-xs text-white/50">

              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;